<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item :label="'Date'" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
<!--                    <a-date-picker-->
<!--                      v-model="queryParam.examineDate"-->
<!--                      format="YYYY-MM-DD"-->
<!--                      style="width: 100%;"/>-->

                    <a-range-picker
                      v-model="queryParam.examineDate"
                      format="YYYY-MM-DD"
                      style="width: 100%;" />
                  </a-form-item>

                </a-col>
                <a-col :span="12">
                  <a-form-item :label="'New/Old User'">
                    <a-select default-value="" style="width: 120px" v-model="queryParam.dataType">
                      <a-select-option value="03">
                        Existing Customer
                      </a-select-option>
                      <a-select-option value="00">
                        New Customer
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="'Stage'">
                    <a-select default-value="" style="width: 120px" v-model="queryParam.stage">
					  <a-select-option value="t0">
                        T-0
                      </a-select-option>
                      <a-select-option value="t1">
                        T-1
                      </a-select-option>
                      <a-select-option value="t2">
                        T-2
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{x:1000}"
        bordered
      >

      </a-table>
<!--      <div style="margin-top: 15px; text-align: right;">-->
<!--          <v-pagination-->
<!--              v-if="total"-->
<!--              :page-num="form.pageNum"-->
<!--              :page-size="form.pageSize"-->
<!--              :total="total"-->
<!--              @change="handleTableChange" />-->
<!--      </div>-->
    </div>
    <v-modal
        v-model="visible"
        :title="$t(I18N_KEY + 'orderDetail')">
        <div style="padding: 20px;">
            <order-detail v-if="visible" :orderId="orderId" :custInfoId="custInfoId"/>
        </div>
    </v-modal>

    <a-modal v-model="visibleO" title="Payment Chain Answer" @ok="handleOk">
       <p>{{ ModalText }}</p>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getPlatformLoanOrderList,
  paymentsLink,
  reductionLateFee,
  repayOfflineAll,
  extendOffline,
  repayStatusCheck,
  getPkPayoutErrorList, loanFailedDeal, getRiskCollectionExcludeTotal
} from
    '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import moment from 'moment'
import vModal from '../modules/Modal';
import OrderDetail from '../order/OrderDetail';
import { getApplist} from '@/webpublicapi/order'
import md5 from 'md5'
const I18N_KEY = 'order.';

export default {
  name: 'LoanOrderlist',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail,
  },
  data () {
    return {
      appList:[],
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      visibleO: false,
      ModalText: '',
      orderId: undefined,
      custInfoId: undefined,
      // Pagination params
      dataSource: [],
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      // Query conditions
      queryParam: {
        "orderNo":"",
        "orderId":undefined,
        "mobileNo":"",
        "aadhaarName":"",
        "applyDate":undefined,
        "paymentDate":undefined,
        "settleDate":undefined,
        "endDate":undefined,
        'appSsids': '',
        // "email":""
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: 'Date',
          align: 'left',
          width: '100px',
          dataIndex: 'dataDate'
        },
        {
          title: 'Stage',
          align: 'left',
          width: '100px',
          dataIndex: 'stage'
        },
        {
          title: 'RealActualDue Date',
          align: 'left',
          width: '200px',
          dataIndex: 'endDate'
        },
        {
          title: 'TotalVolume',
          align: 'left',
          width: '150px',
          dataIndex: 'totalCount'
        },
        {
          title: 'Risk Control Return Collection',
          align: 'left',
          width: '200px',
          dataIndex: 'riskCollect'
        },
        {
          title: 'Risk Control Return No Collection',
          align: 'left',
          width: '200px',
          dataIndex: 'riskUnCollect'
        },
        {
          title: 'Actual No Collection',
          align: 'left',
          width: '200px',
          dataIndex: 'realUnCollect'
        },
        {
          title: 'Actual Collection',
          align: 'left',
          width: '200px',
          dataIndex: 'realCollect'
        },
        {
          title: 'Risk Control Return Collection Same Day Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskCurRepayRate1'
        },
        {
          title: 'Risk Control Return No Collection Same Day Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskCurRepayRate2'
        },
        {
          title: 'Actual No Collection Same Day Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskCurRepayRate3'
        },
        {
          title: 'Actual Collection Same Day Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskCurRepayRate4'
        },
        {
          title: 'Risk Control Return Collection Real-time Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskRepayRate1'
        },
        {
          title: 'Risk Control Return No Collection Real-time Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskRepayRate2'
        },
        {
          title: 'Actual No Collection Real-time Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskRepayRate3'
        },
        {
          title: 'Actual Collection Real-time Repayment Rate',
          align: 'left',
          width: '200px',
          dataIndex: 'riskRepayRate4'
        }
      ]
    },
  },
  created () {
  },
  methods: {

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }

      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getRiskCollectionExcludeTotal(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          // this.total = res.data.total
          this.dataSource = res.data
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const {examineDate} = this.queryParam;
      const data = {
          ...this.queryParam,
        curDateStart: examineDate && this.transformTime(examineDate[0]),
        curDateEnd: examineDate && this.transformTime(examineDate[1]),
          // curDate: examineDate && this.transformTime(moment(examineDate)),
      }
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum
      // param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    handleOk(e) {
      this.ModalText = '';
      this.visibleO = false;
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
